import React from 'react';
import { BookOpenIcon, FileTextIcon, PalmtreeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CroppedImage } from './CroppedImage';
import { BRAND_COMPANY, HERO_EYEBROW, HERO_HEADLINE_ACCENT, HERO_HEADLINE_LEAD, HERO_HEADLINE_TAIL, HERO_MOCKUP, HERO_SUB } from '../data/resinContent';
const INDICATORS = [{
  Icon: FileTextIcon,
  label: '100% PDF'
}, {
  Icon: ZapIcon,
  label: 'Instant access'
}, {
  Icon: BookOpenIcon,
  label: '6 complete volumes'
}, {
  Icon: ShieldCheckIcon,
  label: '7-day guarantee'
}];
export function Hero() {
  return <header className="w-full bg-charcoal-950" data-id="element-177" data-mp="s9zxjd104ykm">
      <div className="mx-auto flex w-full max-w-6xl flex-col px-5 pb-8 pt-3 text-center sm:pt-4 lg:grid lg:grid-cols-[1fr_1.05fr] lg:grid-rows-[auto_auto] lg:items-center lg:gap-x-14 lg:py-14 lg:text-left" data-id="element-178" data-mp="nc86smc3fii0">
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-179" data-mp="382p6pg8rpjmq">
          <p className="flex items-center justify-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.34em] text-ivory-100 lg:justify-start" data-id="element-180" data-mp="384jsewrv5frv">
            <PalmtreeIcon className="h-3.5 w-3.5 text-champagne" strokeWidth={1.5} aria-hidden="true" data-id="element-181" data-mp="3o7vgxbbup7t2" />
            {BRAND_COMPANY}
          </p>
          <p className="mt-2.5 text-[9.5px] font-semibold uppercase tracking-[0.14em] text-champagne sm:mt-3 sm:text-[10px] sm:tracking-[0.24em] lg:mt-6" data-id="element-182" data-mp="39cfjqxfz4vsg">
            {HERO_EYEBROW}
          </p>
          <h1 className="mx-auto mt-2.5 max-w-xl font-display text-[1.75rem] font-semibold uppercase leading-[1.05] text-ivory-50 sm:text-[2.3rem] lg:mx-0 lg:mt-4 lg:text-[3rem]" data-id="element-183" data-mp="30fy8lu7m0xwp">
            {HERO_HEADLINE_LEAD}{' '}
            <span className="block text-champagne-light" data-id="element-184" data-mp="2viy1dfz0xp40">{HERO_HEADLINE_ACCENT}</span>
            {HERO_HEADLINE_TAIL}
          </h1>
          <p className="mx-auto mt-3 max-w-md text-[13px] leading-snug text-body sm:text-[15px] lg:mx-0 lg:mt-5 lg:max-w-lg lg:leading-relaxed" data-id="element-185" data-mp="2hix2g62bkrr6">
            {HERO_SUB}
          </p>
        </div>

        <CroppedImage image={HERO_MOCKUP} loading="eager" className="mx-auto mb-4 mt-4 w-full max-w-[16.5rem] min-[400px]:max-w-[17.5rem] sm:mb-5 sm:mt-5 sm:max-w-sm lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:my-0 lg:max-w-[30rem]" data-id="element-186" data-mp="s2b89zesml5o" />

        <div className="lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-187" data-mp="ddf3qcby3q9t">
          <div className="flex justify-center lg:mt-7 lg:justify-start" data-id="element-188" data-mp="db2ct9o7m5km">
            <CtaButton size="lg" data-id="element-189" data-mp="1azkwdtv2cmt9" />
          </div>
          <ul className="mx-auto mt-4 grid max-w-sm grid-cols-2 gap-x-3 gap-y-2 text-left text-[10px] font-medium uppercase tracking-[0.12em] text-ivory-300 sm:text-[11px] lg:mx-0 lg:flex lg:max-w-none lg:flex-wrap lg:gap-x-5" data-id="element-190" data-mp="161szsmjh4ciq">
            {INDICATORS.map(({
            Icon,
            label
          }) => <li key={label} className="flex items-center justify-center gap-1.5 whitespace-nowrap lg:justify-start" data-id="element-191" data-mp="x3h2y2s0kihu">
                <Icon className="h-3.5 w-3.5 shrink-0 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-192" data-mp="3hrlmup2hqjc5" />
                {label}
              </li>)}
          </ul>
        </div>
      </div>
    </header>;
}